import React from 'react';
import { InView } from 'react-intersection-observer';

import IconDeepResearchVertical from '@components/Images/DeepResearch/IconDeepResearchVertical';
import IconProTagThumbnail from '@components/Images/Rebranding/IconProTagThumbnail';
import LazyImgixImage from '@components/LazyImgixImage';
import useEventTracking from '@hooks/useEventTracking';
import { deep_research_path } from '@routes';
import {
  ClickTarget,
  ImpressionElement,
  Page,
  TrackingLocation,
  click,
  impression,
} from '@tracking';
import { getImgixSrc } from '@utils/images';

const AIPromo = () => {
  const { Track, trackEvent } = useEventTracking({
    location: TrackingLocation.MainRiver,
    page: Page.Homepage,
  });
  return (
    <Track>
      <InView
        triggerOnce={true}
        onChange={(inView) => {
          inView && trackEvent(impression({ impressionElement: ImpressionElement.DeepResearchAd }));
        }}
      >
        <aside className="border-0 border-b border-solid border-grayscale-gray px-0 py-32 sm:py-48">
          <a
            href={deep_research_path()}
            className="group block bg-grayscale-beige"
            onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.DeepResearchAd }))}
          >
            <div className="relative flex flex-col items-center justify-center px-16 py-20 md:px-24 md:py-32 lg:px-72">
              <LazyImgixImage
                role="presentation"
                className="h-[150px] w-auto transition-transform duration-500 ease-in-out group-hover:-rotate-3 group-hover:scale-110 xs:h-[205px]"
                src={getImgixSrc({
                  path: 'homepage/ai_research_promo_v2.png',
                  isEnvDependent: false,
                })}
              />
              <p className="my-20 max-w-full text-center font-suisse-works text-overline-lg xs:max-w-[350px] sm:max-w-[665px] sm:text-subheadline-sm lg:max-w-[733px] lg:text-subheadline-md">
                <span className="block">We didn’t build a better AI.</span>
                <span className="mt-8 block sm:mt-0">
                  We just built one with over a decade of The Information behind it.
                </span>
                <span className="block sm:inline-block">Deep Research is here.</span>
                <span className="mt-8 block sm:mt-0 sm:inline-block">Try it now with Pro.</span>
              </p>
              <IconDeepResearchVertical className="w-[119px]" />
              <IconProTagThumbnail className="absolute right-0 top-0" />
            </div>
          </a>
        </aside>
      </InView>
    </Track>
  );
};

export default AIPromo;
